//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const birdsURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AFdiKOu4wyMmDxhXEvqvZ440YxhDF54z",
    frame: "Bird looks beautiful after a rainy bath",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Ernq_z3AdDuTehxZIUJ-rCCTn2dYLJzk",
    frame: "Few baby birds chirping in the evenings",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16W6C0N4OL20aqlCqcxaFHBpgiTVSs6r6",
    frame: "Macro shot of a housefly",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ItPMAwknu4wPMEirtOp196FNpXRPnRxk",
    frame: "Bird waiting for other birds for chirping",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Xj7nvlsfCMMVHxx-EZSYcoOYdLTMeQQl",
    frame: "Trying to communicate with other birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iuUah-K8qszBT2Aas8Ub_3m3pgyT6n-e",
    frame: "Waiting for longer for other birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sxxZXU4aNvJB6F0DPjNx5v2w2-riFCKI",
    frame: "Stop motion of flying birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Dee1i7yjU9b7IURXTNps8rLqlqXVH2MZ",
    frame: "Spot me!",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1nHt4sYngVv49rqITWLdC91Wvi5ZjBEG6",
    frame: "Group of birds over a mobile tower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1nqEMNLRS9io8A3JyqCpTdlXZInG9769M",
    frame: "Such beautiful expressions given by bird",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1uqPuWEAgU-EZhQh-h4epbeds8c-dH0JN",
    frame: "A loner",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11eSQm6RRWNAcNFHvFZYsTadY2MX7G6pp",
    frame: "Seeing other birds coming by",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-HeSqxz8LmvxmMTEcuoQf9s6rbA_9TdM",
    frame: "Exceptional beauty of birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=17JFmVZW1WYD6XP67lygWMGbIkpIE6Yjo",
    frame: "Bird framed within leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Y8tFhb4Fw6WsiK-ewqM0OKwAL89e03Sw",
    frame: "Silhoutte",
    location: "Meerut, Uttar Pradesh, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=1BoGpriIcHzZoyvuQnPYtFH390zXCQQR_",
    frame: "Looks like eagle? but it's a crow",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1O47B50KeFJGqkiBDRMFJ27KLtj9nivv4",
    frame: "It's also a crow",
    location: "Meerut, Uttar Pradesh, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=11puWFNg-M_1G_iw87bwYpsXrRKB0jFv1",
    frame: "Can you spot?",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1otk8N4ztiZrjqPSlXEQxNRGHE26xRD3S",
    frame: "Pet parrot in my society",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1q6C5t2G7DgwitNornhd6RpkVe0dulBg0",
    frame: "Pet parrot in my society",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14JPNOrCajS0y9uQEBaNBshltSAAwcKps",
    frame: "Pet parrot in my society",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1W6IV_sABHewQeMaonwGcdEatEbgxUe-R",
    frame: "Division of frame for bird and building",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1YUW9vgzCDTU8gzmqGhat25Ah166ulpjo",
    frame: "Got scared when I clicked this bird",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1N2w5Crff7DYPgCBJbg4HBX16_OJoiQay",
    frame: "Spot all three",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AA8GvrcxGvr3uFYmMxeQA71Z34ElEo6q",
    frame: "Natural aeroplane",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Fs9-CFKFy6ydg1-I0i_oLTBjbNfk44ok",
    frame: "Birdy steps",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1D_cp56RuYlSuyYnB2aIi9fyzCPKI_2tu",
    frame: "Natural sky fighters",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16dASbZsdedqdi5pGIo48W-hnjqjhHDEX",
    frame: "Might be playing hide and seek",
    location: "",
  },
];
